import { Routes } from '@angular/router';
import { DashboardError404Page } from '@eforall/dashboard';

import { DevoPipelinePage } from './pages/devo/pipeline/devo-pipeline.page';
import { DevoCommitmentsPage } from './pages/devo/commitments/devo-commitments.page';
import { ConfigurationPlanningPage } from './pages/devo/donors/devo-donors.page';

import { FinanceCostPage } from './pages/finance/cost/finance-cost.page';
import { FinanceAwardsPage } from './pages/finance/awards/finance-awards.page';

import { FramePage } from './pages/frame/frame.page';
import { HomePage } from './pages/home/home.page';

export const routes: Routes = [
	{
		path: '',
		component: FramePage,
		children: [
			{ path: '', component: HomePage },
			{
				path: 'devo',
				data: { breadcrumb: 'Devo' },
				children: [
					{ path: '', redirectTo: 'pipeline', pathMatch: 'full' },
					{ path: 'pipeline', component: DevoPipelinePage, data: { breadcrumb: 'Pipeline', upUrl: '../..' } },
					{ path: 'donors', component: ConfigurationPlanningPage, data: { breadcrumb: 'Donors', upUrl: '../..' } },
					{ path: 'commitments', component: DevoCommitmentsPage, data: { breadcrumb: 'Commitments', upUrl: '../..' } },
				]
			},
			{
				path: 'finance',
				data: { breadcrumb: 'Finance' },
				children: [
					{ path: '', redirectTo: 'awards', pathMatch: 'full' },
					{ path: 'awards', component: FinanceAwardsPage, data: { breadcrumb: 'Awards' } },
					{ path: 'cost', component: FinanceCostPage, data: { breadcrumb: 'Cost' } },
				]
			},
			//
			// Page not found
			//
			{ path: '**', component: DashboardError404Page },
		]
	}

];
